import React, { useState } from "react";

type ClientType = "Client 1" | "Client 2" | "";

interface IClient {
  client: ClientType;
  setClient: React.Dispatch<React.SetStateAction<ClientType>>;
}

const ClientContext = React.createContext<IClient>({
  client: "",
  setClient: client => client
});

export const ClientContextProvider: React.FC = ({ children }) => {
  const [client, setClient] = useState<ClientType>("");

  return (
    <ClientContext.Provider value={{ client, setClient }}>
      {children}
    </ClientContext.Provider>
  );
};

export default ClientContext;
